import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toggleAnswer } from "../../../features/quiz/quizSlice";


const QuizOption = ({ option, quizId }) => {
  const dispatch = useDispatch();
  const [isSelected, setIsSelected] = useState(false);

  const handleSelect = () => {
    setIsSelected(!isSelected)
    dispatch(toggleAnswer({option, quizId}))
  }

  return (
    <label>
    <input
      type="checkbox"
      onClick={handleSelect}
       defaultChecked={isSelected}
    />
    {option.option}
  </label>
  );
};

export default QuizOption;
